@if (review) {
  <div class="row">
    <div class="col-12 col-sm-4">
      <dcp-star-rating [starRating]="review.attributes.star_rating"> </dcp-star-rating>
      <p class="mt-3 mb-0 me-3 me-sm-2 text-black d-inline-block d-md-block">{{ review.attributes.user?.name }}</p>
      <span class="d-inline-block d-md-block mt-1 text-blue-gray body--xxs me-3 me-sm-2">
        <img
          [alt]="'productReview.verifiedReviewer' | cxTranslate"
          class="me-1 d-inline-block g2-logo"
          src="/images/product/review/g2-logo-grey.svg" />
        <span>{{ 'productReview.verifiedReviewer' | cxTranslate }}</span>
      </span>
      <p class="d-inline-block d-md-block mt-1 me-2 text-blue-gray body--xxs">
        {{ review.attributes.published_at | date: 'MMM d, yyyy' }}
      </p>
      <span class="d-inline-block d-md-none"> </span>
    </div>
    <div class="col-12 col-sm-8">
      <dcp-limited-html
        [componentsToToggle]="limitedHtmlSiblings"
        [maxHeight]="160"
        [uniqueId]="review.id"
        class="mb-2">
        <dcp-review-answers [reviewAnswerOrder]="reviewAnswerOrder" [review]="review"></dcp-review-answers>
      </dcp-limited-html>
    </div>
  </div>
}
